'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _util = require('../../util');

var _util2 = _interopRequireDefault(_util);

var _panel = require('../panel');

var _strftime = require('strftime');

var _strftime2 = _interopRequireDefault(_strftime);

var _lodashCompat = require('lodash-compat');

var _data = require('../../util/data');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

//FIXME
var basicPrefixCls = 'month-calendar';
var getCls = function getCls(prefix, basic, suffix) {
  return [prefix + '-' + basic, basic].map(function (item) {
    return '' + item + suffix;
  }).join(' ');
};

/**
 * 月份日历，只能传月份禁用函数
 * props.value
 * props.prefixCls = 'mt' //类前缀
 * props.onSelect = (v) => {} //选中月份时的回调
 * props.disabledDate = (ts) => { return true|false } //ts约定为当月1日0点
 *
 */
var MonthCalendar = (_temp = _class = function (_Component) {
  _inherits(MonthCalendar, _Component);

  function MonthCalendar(props) {
    _classCallCheck(this, MonthCalendar);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(MonthCalendar).call(this, props));

    _this.state = {
      value: props.value || _this._clearDates(Date.now()),
      showPanel: 'month' };
    return _this;
  }

  _createClass(MonthCalendar, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var value = this.state.value;

      if (nextProps.hasOwnProperty('value')) {
        value = nextProps.value || this._clearDates(Date.now());
      }
      this.setState({ value: value });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var prefixCls = _props.prefixCls;
      var className = _props.className;
      var showPanel = this.state.showPanel;

      //className

      var calendarCls = getCls(prefixCls, basicPrefixCls, '');
      var calendarContentCls = getCls(prefixCls, basicPrefixCls, '-content');
      var calendarHeaderCls = getCls(prefixCls, basicPrefixCls, '-header');
      var calendarPanelCls = getCls(prefixCls, basicPrefixCls, '-panel');

      return _react2.default.createElement(
        'div',
        { className: _util2.default.classNames(className, calendarCls) },
        _react2.default.createElement(
          'div',
          { className: _util2.default.classNames(calendarContentCls, { 'active': showPanel == 'month' }) },
          _react2.default.createElement(
            'div',
            { className: calendarHeaderCls },
            this._getMonthHeaderElement()
          ),
          _react2.default.createElement(
            'div',
            { className: calendarPanelCls },
            this._getMonthPanelElement()
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _util2.default.classNames(calendarContentCls, { 'active': showPanel == 'year' }) },
          _react2.default.createElement(
            'div',
            { className: calendarHeaderCls },
            this._getYearHeaderElement()
          ),
          _react2.default.createElement(
            'div',
            { className: calendarPanelCls },
            this._getYearPanelElement()
          )
        )
      );
    }
  }, {
    key: '_getMonthHeaderElement',
    value: function _getMonthHeaderElement() {
      var prefixCls = this.props.prefixCls;
      var value = this.state.value;

      var formatted = (0, _strftime2.default)('%Y', new Date(value));
      return _react2.default.createElement(
        'div',
        { className: prefixCls + '-' + basicPrefixCls + '-month-header' },
        this._getYearSwitcher(-1),
        this._getYearButton(formatted),
        this._getYearSwitcher(1)
      );
    }
  }, {
    key: '_getYearHeaderElement',
    value: function _getYearHeaderElement() {
      var prefixCls = this.props.prefixCls;
      var value = this.state.value;

      var date = new Date(value);
      var year = date.getFullYear();
      var sYear = Number(Math.floor(year / 10) + '0');
      return _react2.default.createElement(
        'div',
        { className: prefixCls + '-' + basicPrefixCls + '-year-header' },
        this._getYearSwitcher(-1),
        sYear + '-' + (sYear + 9),
        this._getYearSwitcher(1)
      );
    }
  }, {
    key: '_getYearSwitcher',
    value: function _getYearSwitcher(arg) {
      var _this2 = this;

      //className
      var prefixCls = this.props.prefixCls;

      var switcherCls = getCls(prefixCls, basicPrefixCls, '-year-switcher');
      var leftSwitcherCls = switcherCls + ' left-switcher';
      var rightSwitcherCls = switcherCls + ' right-switcher';

      var switchYear = function switchYear(arg) {
        var value = _this2.state.value;

        var date = new Date(value);
        _this2._selectYear(date.getFullYear() + arg);
      };
      var showPanel = this.state.showPanel;

      switch (arg) {
        case -1:
          return _react2.default.createElement('span', { className: _util2.default.classNames(leftSwitcherCls, _data.IconPrefixCls + ' ' + _data.IconPrefixCls + '-angle-double-left'),
            onClick: switchYear.bind(this, showPanel == 'year' ? -10 : -1) });
        case 1:
          return _react2.default.createElement('span', { className: _util2.default.classNames(rightSwitcherCls, _data.IconPrefixCls + ' ' + _data.IconPrefixCls + '-angle-double-right'),
            onClick: switchYear.bind(this, showPanel == 'year' ? 10 : 1) });
      }
    }
  }, {
    key: '_getYearButton',
    value: function _getYearButton(year) {
      var _this3 = this;

      //className
      var prefixCls = this.props.prefixCls;

      var yearBtnCls = getCls(prefixCls, basicPrefixCls, '-year-btn');

      var showYearPanel = function showYearPanel() {
        _this3.setState({
          showPanel: 'year'
        });
      };
      return _react2.default.createElement(
        'span',
        { className: yearBtnCls, onClick: showYearPanel },
        _react2.default.createElement(
          'span',
          null,
          year
        ),
        _react2.default.createElement(
          'span',
          null,
          '年'
        )
      );
    }
  }, {
    key: '_getMonthPanelElement',
    value: function _getMonthPanelElement() {
      var prefixCls = this.props.prefixCls;
      var value = this.state.value;

      var props = {
        prefixCls: prefixCls, value: value,
        disabledMonth: this._disabledMonth.bind(this),
        onSelect: this._selectMonth.bind(this)
      };
      return _react2.default.createElement(_panel.MonthPanel, props);
    }
  }, {
    key: '_getYearPanelElement',
    value: function _getYearPanelElement() {
      var _this4 = this;

      var prefixCls = this.props.prefixCls;
      var value = this.state.value;

      var props = {
        prefixCls: prefixCls, value: value,
        onSelect: function onSelect(year) {
          _this4._selectYear(year);
          _this4.setState({
            showPanel: 'month'
          });
        },
        onSwitch: function onSwitch(arg) {
          var value = _this4.state.value;

          var date = new Date(value);
          _this4._selectYear(date.getFullYear() + (arg < 0 ? -10 : 10));
        }
      };
      return _react2.default.createElement(_panel.YearPanel, props);
    }
  }, {
    key: '_selectMonth',
    value: function _selectMonth(month) {
      var _this5 = this;

      var value = this.state.value;

      var date = new Date(value);
      var dateBefore = date.getDate();
      date.setMonth(month);
      //选择/切换月份时如果没有该日，例如5-31切换到4月
      if (date.getDate() !== dateBefore) {
        date.setMonth(month + 1, 1);
        date.setDate(date.getDate() - 1);
      }
      this.setState({
        value: date.getTime()
      }, function () {
        var onSelect = _this5.props.onSelect;

        onSelect(_this5.state.value);
      });
    }
  }, {
    key: '_selectYear',
    value: function _selectYear(year) {
      var value = this.state.value;

      var date = new Date(value);
      var monthBefore = date.getMonth(),
          dateBefore = date.getDate();
      date.setFullYear(year);
      //切换年时如果没有该日，例如2016-2-29切换到2015年
      if (date.getMonth() !== monthBefore || date.getDate() !== dateBefore) {
        date.setMonth(monthBefore + 1, 1);
        date.setDate(date.getDate() - 1);
      }
      this.setState({
        value: date.getTime()
      });
    }

    /**
     * 清除 时 分 秒 信息，设为当月1日
     * @param ts
     * @returns {number}
     * @private
     */

  }, {
    key: '_clearDates',
    value: function _clearDates(ts) {
      var date = new Date(ts);
      date.setDate(1);
      date.setHours(0, 0, 0, 0);
      return date.getTime();
    }
  }, {
    key: '_disabledMonth',
    value: function _disabledMonth(month) {
      var disabledDate = this.props.disabledDate;
      var value = this.state.value;

      var date = new Date(value);
      date.setMonth(month);

      return !!disabledDate && disabledDate(date.getTime());
    }
  }]);

  return MonthCalendar;
}(_react.Component), _class.propTypes = {
  value: _propTypes2.default.number,
  prefixCls: _propTypes2.default.string,
  onSelect: _propTypes2.default.func,
  disabledDate: _propTypes2.default.func
}, _class.defaultProps = {
  prefixCls: 'mt',
  onSelect: _lodashCompat.noop,
  disabledDate: _lodashCompat.noop
}, _temp);
exports.default = MonthCalendar;